import yup from '@/utils/yup-extended'

export class LoginModel {
  phone?: string | undefined = ''
  email?: string | undefined = ''
  type?: 'phone' | 'email' = 'email'
  token?: string | null = null
  step?: 'verify' | 'verify_2fa' | 'finish'
  code?: string
}

export interface LoginResponse {
  step: 'verify' | 'verify_2fa'
  token: string
  next_step?: 'finish'
}

// Схема для типа "email"
export const LoginEmailValidationSchema = yup.object({
  email: yup.string().email('Email is not valid').required('Email is required'),
  type: yup
    .string()
    .oneOf(['email'], 'Type must be email')
    .required('Type is required'),
})

// Схема для типа "phone"
export const LoginPhoneValidationSchema = yup.object({
  phone: yup
    .string()
    .matches(/^\+?\d{10,15}$/, 'Phone number is not valid')
    .required('Phone number is required'),
  type: yup
    .string()
    .oneOf(['phone'], 'Type must be phone')
    .required('Type is required'),
})

export const LoginCodeValidationSchema = yup.object().shape({
  code: yup.string().required(),
  token: yup.string().required(),
})

export interface LoginView {
  actions: 'email' | 'phone' | '2fa' | 'code'
  component: JSX.Element
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  schema: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValues: Record<string, any>
}
